import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type { Order, OrderFromTmsFilters } from '@models/order'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import ordersApi from './actions'
import { ordersKeys } from './constants'

interface UseTmsOrdersProps {
  orders: Order[]
  ordersMap: Map<number, Order>
  pagination: PaginationMeta
}

const selectData = ({
  data,
  pagination,
}: PaginatedResponse<Order>): UseTmsOrdersProps => {
  return {
    orders: data,
    ordersMap: new Map(data.map(order => [order.id, order])),
    pagination,
  }
}

const useTmsOrders = (filters: OrderFromTmsFilters) => {
  const query = useQuery<
    PaginatedResponse<Order>,
    AxiosError,
    UseTmsOrdersProps
  >(ordersKeys.erpOrders(filters), () => ordersApi.getTmsOrders(filters), {
    select: selectData,
  })

  return query
}

export default useTmsOrders
